// extracted by mini-css-extract-plugin
export default {"root":"InputTitle_root__+SaXA","inputRequired":"InputTitle_inputRequired__H-3nH"};